<template>
    <div ref="root">
        <BlockList :blocks="content.blocks"
                   disable-container-for-first-block
                   :class="{'mt-20': !isTakeOverEnabled }"/>

        <DevelopmentOnlyLinks v-if="isDevMode()"
                              class="o-container mt-40"/>
    </div>
</template>

<script setup lang="ts">
import { Ref, ref, computed, onBeforeUnmount, onMounted, defineAsyncComponent } from 'vue';
import { FrontpageViewModel } from '@/types/contentServerContract';
import { isDevMode } from '@/core/environmentService';
import appStore from '@/core/app/app.store';
import themeService from '@/project/app/themes/theme.service';
import breakpointService from '@/core/responsive/breakpoints/breakpoints.service';
import { LG, XL } from '@/core/config/breakpointConfig';
const DevelopmentOnlyLinks = defineAsyncComponent(() => import('@/project/app/content-pages/DevelopmentOnlyLinks.vue'));

const props = defineProps({
    content: { type: Object as () => FrontpageViewModel, required: true },
});
const isTakeOverEnabled = computed(() => themeService.isTakeOverEnabled);
const isLg = computed(() => breakpointService.isActiveBreakpoint(LG));
const isXl = computed(() => breakpointService.isActiveBreakpoint(XL));
const root: Ref<HTMLElement | null> = ref(null);

onBeforeUnmount(() => {
    appStore.hideMobileSearch = false;
    appStore.isFrontPage = false;
});

onMounted(() => {
    appStore.hideMobileSearch = true;
    appStore.isFrontPage = true;
    appStore.setHideBreadcrumb(true);
    if (isLg.value || isXl.value) {
        if (root.value) {
            root.value.style.minHeight = `${2400}px`;
        }
    }
});
</script>
